import script from "./TrainerList.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerList.vue?vue&type=script&setup=true&lang=js"

import "./TrainerList.vue?vue&type=style&index=0&id=efb0a31e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efb0a31e"]])

export default __exports__